"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObfuscatedOperatorType = exports.OperatorType = void 0;
exports.matchesRule = matchesRule;
/* eslint-disable @typescript-eslint/no-explicit-any */
const semver_1 = require("semver");
const obfuscation_1 = require("./obfuscation");
var OperatorType;
(function (OperatorType) {
    OperatorType["MATCHES"] = "MATCHES";
    OperatorType["NOT_MATCHES"] = "NOT_MATCHES";
    OperatorType["GTE"] = "GTE";
    OperatorType["GT"] = "GT";
    OperatorType["LTE"] = "LTE";
    OperatorType["LT"] = "LT";
    OperatorType["ONE_OF"] = "ONE_OF";
    OperatorType["NOT_ONE_OF"] = "NOT_ONE_OF";
    OperatorType["IS_NULL"] = "IS_NULL";
})(OperatorType || (exports.OperatorType = OperatorType = {}));
var ObfuscatedOperatorType;
(function (ObfuscatedOperatorType) {
    ObfuscatedOperatorType["MATCHES"] = "05015086bdd8402218f6aad6528bef08";
    ObfuscatedOperatorType["NOT_MATCHES"] = "8323761667755378c3a78e0a6ed37a78";
    ObfuscatedOperatorType["GTE"] = "32d35312e8f24bc1669bd2b45c00d47c";
    ObfuscatedOperatorType["GT"] = "cd6a9bd2a175104eed40f0d33a8b4020";
    ObfuscatedOperatorType["LTE"] = "cc981ecc65ecf63ad1673cbec9c64198";
    ObfuscatedOperatorType["LT"] = "c562607189d77eb9dfb707464c1e7b0b";
    ObfuscatedOperatorType["ONE_OF"] = "27457ce369f2a74203396a35ef537c0b";
    ObfuscatedOperatorType["NOT_ONE_OF"] = "602f5ee0b6e84fe29f43ab48b9e1addf";
    ObfuscatedOperatorType["IS_NULL"] = "dbd9c38e0339e6c34bd48cafc59be388";
})(ObfuscatedOperatorType || (exports.ObfuscatedOperatorType = ObfuscatedOperatorType = {}));
var OperatorValueType;
(function (OperatorValueType) {
    OperatorValueType["PLAIN_STRING"] = "PLAIN_STRING";
    OperatorValueType["STRING_ARRAY"] = "STRING_ARRAY";
    OperatorValueType["SEM_VER"] = "SEM_VER";
    OperatorValueType["NUMERIC"] = "NUMERIC";
})(OperatorValueType || (OperatorValueType = {}));
function matchesRule(rule, subjectAttributes, obfuscated) {
    const conditionEvaluations = evaluateRuleConditions(subjectAttributes, rule.conditions, obfuscated);
    return !conditionEvaluations.includes(false);
}
function evaluateRuleConditions(subjectAttributes, conditions, obfuscated) {
    return conditions.map((condition) => obfuscated
        ? evaluateObfuscatedCondition(Object.entries(subjectAttributes).reduce((accum, [key, val]) => ({ [(0, obfuscation_1.getMD5Hash)(key)]: val, ...accum }), {}), condition)
        : evaluateCondition(subjectAttributes, condition));
}
function evaluateCondition(subjectAttributes, condition) {
    const value = subjectAttributes[condition.attribute];
    if (condition.operator === OperatorType.IS_NULL) {
        if (condition.value) {
            return value === null || value === undefined;
        }
        return value !== null && value !== undefined;
    }
    if (value != null) {
        switch (condition.operator) {
            case OperatorType.GTE:
            case OperatorType.GT:
            case OperatorType.LTE:
            case OperatorType.LT: {
                const conditionValueType = targetingRuleConditionValuesTypesFromValues(condition.value);
                if (conditionValueType === OperatorValueType.SEM_VER) {
                    const comparator = condition.operator === OperatorType.GTE
                        ? semver_1.gte
                        : condition.operator === OperatorType.GT
                            ? semver_1.gt
                            : condition.operator === OperatorType.LTE
                                ? semver_1.lte
                                : semver_1.lt;
                    return compareSemVer(value, condition.value, comparator);
                }
                const comparator = (a, b) => condition.operator === OperatorType.GTE
                    ? a >= b
                    : condition.operator === OperatorType.GT
                        ? a > b
                        : condition.operator === OperatorType.LTE
                            ? a <= b
                            : a < b;
                return compareNumber(value, condition.value, comparator);
            }
            case OperatorType.MATCHES:
                return new RegExp(condition.value).test(value);
            case OperatorType.NOT_MATCHES:
                return !new RegExp(condition.value).test(value);
            case OperatorType.ONE_OF:
                return isOneOf(value.toString(), condition.value);
            case OperatorType.NOT_ONE_OF:
                return isNotOneOf(value.toString(), condition.value);
        }
    }
    return false;
}
function evaluateObfuscatedCondition(hashedSubjectAttributes, condition) {
    const value = hashedSubjectAttributes[condition.attribute];
    if (condition.operator === ObfuscatedOperatorType.IS_NULL) {
        if (condition.value === (0, obfuscation_1.getMD5Hash)('true')) {
            return value === null || value === undefined;
        }
        return value !== null && value !== undefined;
    }
    if (value != null) {
        switch (condition.operator) {
            case ObfuscatedOperatorType.GTE:
            case ObfuscatedOperatorType.GT:
            case ObfuscatedOperatorType.LTE:
            case ObfuscatedOperatorType.LT: {
                const conditionValue = (0, obfuscation_1.decodeBase64)(condition.value);
                const conditionValueType = targetingRuleConditionValuesTypesFromValues(conditionValue);
                if (conditionValueType === OperatorValueType.SEM_VER) {
                    const comparator = condition.operator === ObfuscatedOperatorType.GTE
                        ? semver_1.gte
                        : condition.operator === ObfuscatedOperatorType.GT
                            ? semver_1.gt
                            : condition.operator === ObfuscatedOperatorType.LTE
                                ? semver_1.lte
                                : semver_1.lt;
                    return compareSemVer(value, conditionValue, comparator);
                }
                const comparator = (a, b) => condition.operator === ObfuscatedOperatorType.GTE
                    ? a >= b
                    : condition.operator === ObfuscatedOperatorType.GT
                        ? a > b
                        : condition.operator === ObfuscatedOperatorType.LTE
                            ? a <= b
                            : a < b;
                return compareNumber(value, Number(conditionValue), comparator);
            }
            case ObfuscatedOperatorType.MATCHES:
                return new RegExp((0, obfuscation_1.decodeBase64)(condition.value)).test(value);
            case ObfuscatedOperatorType.NOT_MATCHES:
                return !new RegExp((0, obfuscation_1.decodeBase64)(condition.value)).test(value);
            case ObfuscatedOperatorType.ONE_OF:
                return isOneOf((0, obfuscation_1.getMD5Hash)(value.toString()), condition.value);
            case ObfuscatedOperatorType.NOT_ONE_OF:
                return isNotOneOf((0, obfuscation_1.getMD5Hash)(value.toString()), condition.value);
        }
    }
    return false;
}
function isOneOf(attributeValue, conditionValue) {
    return getMatchingStringValues(attributeValue, conditionValue).length > 0;
}
function isNotOneOf(attributeValue, conditionValue) {
    return getMatchingStringValues(attributeValue, conditionValue).length === 0;
}
function getMatchingStringValues(attributeValue, conditionValues) {
    return conditionValues.filter((value) => value === attributeValue);
}
function compareNumber(attributeValue, conditionValue, compareFn) {
    return compareFn(Number(attributeValue), Number(conditionValue));
}
function compareSemVer(attributeValue, conditionValue, compareFn) {
    return (!!(0, semver_1.valid)(attributeValue) &&
        !!(0, semver_1.valid)(conditionValue) &&
        compareFn(attributeValue, conditionValue));
}
function targetingRuleConditionValuesTypesFromValues(value) {
    // Check if input is a number
    if (typeof value === 'number') {
        return OperatorValueType.NUMERIC;
    }
    if (Array.isArray(value)) {
        return OperatorValueType.STRING_ARRAY;
    }
    // Check if input is a string that represents a SemVer
    if (typeof value === 'string' && (0, semver_1.valid)(value)) {
        return OperatorValueType.SEM_VER;
    }
    // Check if input is a string that represents a number
    if (!isNaN(Number(value))) {
        return OperatorValueType.NUMERIC;
    }
    // If none of the above, it's a general string
    return OperatorValueType.PLAIN_STRING;
}
//# sourceMappingURL=rules.js.map